var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "AI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.294 7.436.803 2.23c.892 2.475 2.841 4.424 5.316 5.316l2.23.803c.201.073.201.358 0 .43l-2.23.803c-2.475.892-4.424 2.841-5.316 5.316l-.803 2.23c-.073.201-.358.201-.43 0l-.803-2.23c-.892-2.475-2.841-4.424-5.316-5.316l-2.23-.803c-.201-.073-.201-.358 0-.43l2.23-.803c2.475-.892 4.424-2.841 5.316-5.316l.803-2.23c.072-.202.357-.202.43 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.332 2.077.407 1.129c.452 1.253 1.439 2.24 2.692 2.692l1.129.407c.102.037.102.181 0 .218l-1.129.407c-1.253.452-2.24 1.439-2.692 2.692l-.407 1.129c-.037.102-.181.102-.218 0l-.407-1.129c-.452-1.253-1.439-2.24-2.692-2.692l-1.129-.407c-.102-.037-.102-.181 0-.218l1.129-.407c1.253-.452 2.24-1.439 2.692-2.692l.407-1.129c.037-.103.182-.103.218 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.332 21.25.407 1.129c.452 1.253 1.439 2.24 2.692 2.692l1.129.407c.102.037.102.181 0 .218l-1.129.407c-1.253.452-2.24 1.439-2.692 2.692l-.407 1.129c-.037.102-.181.102-.218 0l-.407-1.129c-.452-1.253-1.439-2.24-2.692-2.692l-1.129-.407c-.102-.037-.102-.181 0-.218l1.129-.407c1.253-.452 2.24-1.439 2.692-2.692l.407-1.129c.037-.102.182-.102.218 0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "artificial_intelligence"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ai_image_generator"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ai_assistant"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "prompt"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ai_message"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ai_cloud"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "data"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "ai_photo_generator"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "innovation"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "ai_voice_generator"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "migration"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "setting"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "connection"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "protection"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "brain"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "website"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "ai_text_generator"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "regenerate"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "ai_3d_generator"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "ai_document_generator"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "ai_video_generator"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "cloud_data"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "automation"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.ed2484cc24fdb724e2d8cfff082ed6a5.svg";
export { ForwardRef as ReactComponent };